import * as React from 'react';

import { PictureProfile } from '../../../../../ResizedImage/PictureProfile.csharp';
import { getTranslation, keys } from '../../../../../Resources/Translations';
import { formatAddressToDisplay } from '../../../../Customers/Addresses/Components/formatAddress';
import { AddressViewModel } from '../../../../Customers/Addresses/ViewModels/AddressViewModel.csharp';
import CartItem from '../../../../Purchase/Cart/Item/Components/CartItem/CartItem';
import { CartItemViewModel } from '../../../../Purchase/Cart/Item/ViewModels/CartItemViewModel.csharp';

interface OrderDetailsPackageProps {
    packageNumber: number;
    isSent: boolean;
    trackingUrl: string;
    totalPackagesAmount: number;
    shippingDisplayName: string;
    address: AddressViewModel;
    items: CartItemViewModel[];
    pictureProfile: PictureProfile;
    isPackageInfoAvailable: boolean;
    rxLoginBaseUrl?: string;
    favouritesUrl: string;
}

export const OrderDetailsPackage = (props: OrderDetailsPackageProps) => {
    const { packageNumber, totalPackagesAmount, shippingDisplayName, rxLoginBaseUrl, address, items, pictureProfile } = props;

    return (
        <div className="OrderDetailsPackage CartItems--NotEditable">
            <div className="OrderDetailsPackage__Header">
                {totalPackagesAmount > 1 && (
                    <div className="OrderDetailsPackage__Shipping">
                        <span className="OrderDetailsPackage__Heading">
                            {`${getTranslation(keys['orderSummary.package'])} ${packageNumber} ${getTranslation(
                                keys['orderSummary.of']
                            )} ${totalPackagesAmount}`}
                        </span>
                    </div>
                )}
                <div className="OrderDetailsPackage__Delivery">
                    <span className="OrderDetailsPackage__Heading">{shippingDisplayName}:</span>
                    <span className="OrderDetailsPackage__Details">{formatAddressToDisplay(address, false)}</span>
                </div>
                {props.isSent && props.trackingUrl && (
                    <a
                        className="OrderDetails__Button OrderDetails__Button--Dark OrderDetails__Button--Package"
                        href={props.trackingUrl}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {getTranslation(keys['orderSummary.packageTracking'])}
                    </a>
                )}
            </div>
            <div className="OrderDetailsPackage__Items">
                {items.map((item) => (
                    <CartItem
                        key={item.code}
                        item={item}
                        pictureProfile={pictureProfile}
                        favouritesUrl={props.favouritesUrl}
                        hideItemAvailability
                        showQuantity
                        showFavouriteButton
                        priceLayout="checkout"
                    />
                ))}
                {rxLoginBaseUrl && (
                    <div className="OrderDetailsPackage__RxLogin">
                        <iframe src={rxLoginBaseUrl} scrolling="no" sandbox="allow-same-origin allow-top-navigation-by-user-activation" />
                    </div>
                )}
            </div>
        </div>
    );
};
